import React from 'react';
export function Footer() {
  return <footer className="bg-slate-950 py-12 text-center text-slate-400" data-id="element-82">
      <div className="container mx-auto px-4" data-id="element-83">
        <p className="mb-4 text-sm font-medium" data-id="element-84">
          © 2026 KIT Psicólogo Deportivo. Todos los derechos reservados.
        </p>
        <p className="mx-auto max-w-2xl text-xs leading-relaxed opacity-60" data-id="element-85">
          Este sitio no es parte del sitio web de Facebook o Meta Inc. Además,
          este sitio NO está respaldado por Facebook de ninguna manera.
        </p>
      </div>
    </footer>;
}